<template>
  <div class="content-section">
    <Heading
      class="content-section__heading"
      :level="2"
      data-testid="section-heading"
    >
      {{ section.name }}
    </Heading>

    <Row
      v-for="(article, articleIndex) in section.articles"
      :key="articleIndex"
      :left-title="article.title"
      :has-line="articleIndex === 0"
      data-testid="article-row"
      has-interaction
      chevron
      @click="openArticle(article)"
    />

    <Row
      v-if="hasMoreArticlesToShow"
      data-testid="see-all"
      chevron
      has-interaction
      @click="openSection(section)"
    >
      <template #top-left>
        <strong class="text-p5-semibold">Ver todos</strong>
      </template>
    </Row>
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  IHelpCenterArticle,
  IHelpCenterSection
} from '@/modules/help-center/services/help-center';

import { Row, Heading } from '@warrenbrasil/nebraska-web';

@Component({
  name: 'HelpCenterContentSection',
  components: { Heading, Row }
})
export default class HelpCenterContentSection extends Vue {
  @Prop({ type: Object as PropType<IHelpCenterSection>, required: true })
  readonly section!: IHelpCenterSection;

  get hasMoreArticlesToShow() {
    const { articles, totalArticles } = this.section;
    return articles?.length! < totalArticles!;
  }

  openSection(section: IHelpCenterSection) {
    this.$router.push({
      name: 'help-center-section',
      params: { id: String(section.id) }
    });
  }

  openArticle(article: IHelpCenterArticle) {
    this.$router.push({
      name: 'help-center-article',
      params: { articleId: String(article.id) }
    });
  }
}
</script>

<style lang="less" scoped>
.content-section {
  padding-bottom: @size-spacing-x600;

  &__heading {
    padding-bottom: @size-spacing-x400;
  }
}
</style>
